import { MigrationSectionsStatuses } from 'api/auth/types'
import { useNavigate } from 'react-router-dom'
import { URLS } from 'constants/urls'
import { useApiRequest } from './useApiRequest'
import { profileApi } from 'api'

const MIGRATION_STATUS_TO_URL: Record<keyof MigrationSectionsStatuses, string> =
  {
    profileStatus: URLS.PROFILE + URLS.DETAILS,
    equipmentStatus: URLS.FLEET + URLS.EQUIPMENTS,
    locationsStatus: URLS.LOCATIONS + URLS.LIST_OF_LOCATIONS,
    carsStatus: URLS.FLEET + URLS.VEHICLES,
    priceListsStatus: URLS.FLEET + URLS.PRICE_LIST,
    termsConditionsStatus: URLS.TERMS_AND_CONDITIONS + URLS.RENTAL_INCLUDES,
  }

export const useMigrationRedirect = () => {
  const navigate = useNavigate()
  const getCompanyInfoRequest = useApiRequest(
    (companyId) => profileApi.getCompanyShortInfo(companyId),
    '',
    true
  )

  const redirect = async (
    companyId: number,
    currentSection: keyof MigrationSectionsStatuses
  ) => {
    const response = await getCompanyInfoRequest.apiRequest(companyId)
    if (response) {
      if (
        response.data.migrationSectionsStatuses[currentSection] === 'Complete'
      ) {
        const incompleteSection = Object.entries(
          response.data.migrationSectionsStatuses
        ).find(([, value]) => value === 'Incomplete')
        if (incompleteSection) {
          const [sectionKey] = incompleteSection
          const url =
            MIGRATION_STATUS_TO_URL[
              sectionKey as keyof MigrationSectionsStatuses
            ]
          navigate(url)
          return
        }
      }
    }
  }

  return { redirect }
}
